import * as React from 'react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { observer } from 'mobx-react';
var styles = require('./ComposeTop.scss');
var ImportanceIcon = observer(function (props) {
    var importance = props.importance;
    if (!importance || importance == 'Normal') {
        return null;
    }
    var isHighImportance = importance == 'High';
    return (React.createElement(Icon, { key: "importance", className: isHighImportance ? styles.importanceIcon : null, iconName: isHighImportance ? "Important" /* Important */ : "Down" /* Down */ }));
});
export default ImportanceIcon;
//# sourceMappingURL=ImportanceIcon.js.map